/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import IconSet from './IconSet';
import Temperature from './Temperature';

/**
* The DailyWeather model module.
* @module model/DailyWeather
* @version 2020-12-7
*/
export default class DailyWeather {
    /**
    * Constructs a new <code>DailyWeather</code>.
    * @alias module:model/DailyWeather
    * @class
    * @param _date {Number} 
    * @param temperatures {module:model/Temperature} 
    * @param label {String} 
    * @param description {String} 
    * @param icons {module:model/IconSet} 
    */

    constructor(_date, temperatures, label, description, icons) {
        
        
        this['date'] = _date;
        this['temperatures'] = temperatures;
        this['label'] = label;
        this['description'] = description;
        this['icons'] = icons;
        
    }

    /**
    * Constructs a <code>DailyWeather</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/DailyWeather} obj Optional instance to populate.
    * @return {module:model/DailyWeather} The populated <code>DailyWeather</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DailyWeather();
                        
            
            if (data.hasOwnProperty('date')) {
                obj['date'] = ApiClient.convertToType(data['date'], 'Number');
            }
            if (data.hasOwnProperty('temperatures')) {
                obj['temperatures'] = Temperature.constructFromObject(data['temperatures']);
            }
            if (data.hasOwnProperty('label')) {
                obj['label'] = ApiClient.convertToType(data['label'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('icons')) {
                obj['icons'] = IconSet.constructFromObject(data['icons']);
            }
        }
        return obj;
    }

    /**
    * @member {Number} date
    */
    'date' = undefined;
    /**
    * @member {module:model/Temperature} temperatures
    */
    'temperatures' = undefined;
    /**
    * @member {String} label
    */
    'label' = undefined;
    /**
    * @member {String} description
    */
    'description' = undefined;
    /**
    * @member {module:model/IconSet} icons
    */
    'icons' = undefined;




}
